<script>

export default {
	data() {
		return {
			stateList: [
				{
					state: "ACT",
					name: "Australian Capital Territory",
					bdmList: [
						{
							firstName: "Stella",
							lastName: "Hritis",
							leisureCorporate: "Leisure Sales BDM - NSW/ACT",
							location:
								"New South Wales and Australian Capital Territory",
							funFact:
								"I have travelled to over 90 countries",
							salesTipHeadline: "Economy Skycouch™",
							salesTip: 'Did you know that you can book the Economy Skycouch™ in the GDS?<div class="pt-3"></div>See our <a href="https://www.airnzagent.com.au/gds-user-guides" target="_blank" rel="noopener noreferrer" style="text-decoration:underline;color:#734CA4;">Skycouch booking guides</a> to find out more.',
							email: "stella.hritis@airnz.co.nz ",
							phoneNumber: "+61 438 816 782",
							image: "Stella.H.jpg",
							bookings:
								"mailto:stella.hritis@airnz.co.nz",
							videoIntroduction: "/video/bdm/Stella+AIRNZ-32681-E-1+%E2%80%A2+Sydney+BDM+Introduction+Videos+%E2%80%A2+Deliverable+%E2%80%A2+NA+%E2%80%A2+240201.mov",
							videoIntroductionIndex: 3
						},
						{
							firstName: "Sharee",
							lastName: "Stolarski",
							leisureCorporate: "Corporate & TMC BDM - NSW/ACT",
							location:
								"New South Wales and Australian Capital Territory",
							funFact:
								"While working at London Heathrow airport as a Premium Customer Service agent, I was lucky enough to escort and meet some celebrities like Drew Barrymore, Sharon Stone and The Rock.",
							salesTipHeadline: "Western Sydney International (WSI)",
							salesTip: "The new Western Sydney International Airport (WSI) flights to Auckland take off from 26 October, giving your customers more choice and seamless connections across domestic New Zealand, the Pacific Islands and North America.",
							email: "sharee.stolarski@airnz.co.nz",
							phoneNumber: "+61 414 747 270",
							image: "Sharee.T.jpg",
							bookings:
								"mailto:sharee.stolarski@airnz.co.nz",
						},
						{
							firstName: "Kate",
							lastName: "Aitken",
							leisureCorporate: "National Group Sales BDM",
							location:
								"National",
							funFact:
								"I have never once missed a flight and have worked in the travel industry for 14 years.",
							salesTipHeadline: "Groups - 2x 23kg Bags",
							salesTip: 'For groups, the inclusion of two checked 23kg bags per person on our long haul routes is a key advantage. Making it easy to travel with bulky equipment while avoiding excess baggage fees.',
							email: "kate.aitken@airnz.co.nz",
							phoneNumber: "+61 420 472 648",
							image: "kate.aitken.png",
							bookings:
								"mailto:kate.aitken@airnz.co.nz",
						},
					],
				},
				{
					state: "NSW",
					name: "New South Wales",
					bdmList: [
						{
							firstName: "Stella",
							lastName: "Hritis",
							leisureCorporate: "Leisure Sales BDM - NSW/ACT",
							location:
								"New South Wales and Australian Capital Territory",
							funFact:
								"I have travelled to over 90 countries",
							salesTipHeadline: "Economy Skycouch™",
							salesTip: 'Did you know that you can book the Economy Skycouch™ in the GDS?<div class="pt-3"></div>See our <a href="https://www.airnzagent.com.au/gds-user-guides" target="_blank" rel="noopener noreferrer" style="text-decoration:underline;color:#734CA4;">Skycouch booking guides</a> to find out more.',
							email: "stella.hritis@airnz.co.nz ",
							phoneNumber: "+61 438 816 782",
							image: "Stella.H.jpg",
							bookings:
								"mailto:stella.hritis@airnz.co.nz",
							videoIntroduction: "/video/bdm/Stella+AIRNZ-32681-E-1+%E2%80%A2+Sydney+BDM+Introduction+Videos+%E2%80%A2+Deliverable+%E2%80%A2+NA+%E2%80%A2+240201.mov",
							videoIntroductionIndex: 3
						},
						{
							firstName: "Sharee",
							lastName: "Stolarski",
							leisureCorporate: "Corporate & TMC BDM - NSW/ACT",
							location:
								"New South Wales and Australian Capital Territory",
							funFact:
								"While working at London Heathrow airport as a Premium Customer Service agent, I was lucky enough to escort and meet some celebrities like Drew Barrymore, Sharon Stone and The Rock.",
							salesTipHeadline: "Western Sydney International (WSI)",
							salesTip: "The new Western Sydney International Airport (WSI) flights to Auckland take off from 26 October, giving your customers more choice and seamless connections across domestic New Zealand, the Pacific Islands and North America.",
							email: "sharee.stolarski@airnz.co.nz",
							phoneNumber: "+61 414 747 270",
							image: "Sharee.T.jpg",
							bookings:
								"mailto:sharee.stolarski@airnz.co.nz",
						},
						{
							firstName: "Kate",
							lastName: "Aitken",
							leisureCorporate: "National Group Sales BDM",
							location:
								"National",
							funFact:
								"I have never once missed a flight and have worked in the travel industry for 14 years.",
							salesTipHeadline: "Groups - 2x 23kg Bags",
							salesTip: 'For groups, the inclusion of two checked 23kg bags per person on our long haul routes is a key advantage. Making it easy to travel with bulky equipment while avoiding excess baggage fees.',
							email: "kate.aitken@airnz.co.nz",
							phoneNumber: "+61 420 472 648",
							image: "kate.aitken.png",
							bookings:
								"mailto:kate.aitken@airnz.co.nz",
						},
					],
				},
				{
					state: "QLD",
					name: "Queensland",
					bdmList: [
						{
							firstName: "Nick",
							lastName: "Lewis",
							leisureCorporate: "Leisure Sales BDM - QLD/NNSW",
							location:
								"Queensland and Northern New South Wales",
							funFact:
								"I have a passion for travel and discovering new destinations. Whenever I’m abroad, I make a point of joining a local cooking class, it’s one of my favourite ways to connect with the culture and experience a place more authentically.",
							salesTipHeadline: "New Cabin Experience",
							salesTip: "Boost booking value and earn commission by showcasing our new long-haul cabin experience on the 787 Dreamliner, including Business Premier Luxe™, or enhance your customers Economy journey by adding on a Skycouch, or the new Economy Skynest™ (AKL–JFK from late 2026).",
							email: "nick.lewis@airnz.co.nz",
							phoneNumber: "+61 427 675 335",
							image: "Nick.L.jpg",
							bookings: "mailto:nick.lewis@airnz.co.nz",
							videoIntroduction: '/video/bdm/AIRNZ-32091-A-3%20%E2%80%A2%20Fare%20Booking%20Micro%20Video%20%28Brisbane%29%20BDM%20Intro%20%E2%80%A2%20Deliverable%20%E2%80%A2%20%CA%80%E1%B4%84%20%E2%80%A2%20231107.mov',
							
						},
						{
							firstName: "Gabriel",
							lastName: "Fonseca",
							leisureCorporate: "Corporate & TMC BDM - QLD/NNSW",
							location:
								"Queensland and Northern New South Wales",
							funFact:
								"I speak 3 languages, and worked in television for 10 years before working in airlines.",
							salesTipHeadline: "Renowned kiwi service",
							salesTip: "theworks is a great Economy product option when flying across the Tasman, experience fresh New Zealand cuisine and amazing wine included in the fare.",
							email: "gabriel.fonseca@airnz.co.nz",
							phoneNumber: "+61 410 138 264",
							image: "Gabriel.F.jpeg",
							bookings: "mailto:gabriel.fonseca@airnz.co.nz",
							videoIntroduction: '/video/bdm/Gabriel+AIRNZ-32681-F-1+%E2%80%A2+Sydney+BDM+Introduction+Videos+%E2%80%A2+Approval+Candidate+%E2%80%A2+NA+%E2%80%A2+240129.mov',
							videoIntroductionIndex: 2
						},
						{
							firstName: "Kate",
							lastName: "Aitken",
							leisureCorporate: "National Group Sales BDM",
							location:
								"National",
							funFact:
								"I have never once missed a flight and have worked in the travel industry for 14 years.",
							salesTipHeadline: "Groups - 2x 23kg Bags",
							salesTip: 'For groups, the inclusion of two checked 23kg bags per person on our long haul routes is a key advantage. Making it easy to travel with bulky equipment while avoiding excess baggage fees.',
							email: "kate.aitken@airnz.co.nz",
							phoneNumber: "+61 420 472 648",
							image: "kate.aitken.png",
							bookings:
								"mailto:kate.aitken@airnz.co.nz",
						},
					],
				},
				{
					state: "SA&TAS",
					name: "South Australia and Tasmania",
					bdmList: [
						{
							firstName: "Karen",
							lastName: "Koval",
							leisureCorporate: "Leisure Sales and Corporate & TMC BDM - SA/TAS",
							location:
								"South Australia and Tasmania",
							funFact:
								"I enjoy finding a horse ride whenever I visit a new destination - even if it means coming home with a little soreness in my stride. NZ offers some of the most spectacular landscapes to make every moment in the saddle worth it.",
							salesTipHeadline: "Economy Skycouch",
							salesTip: 'Air NZ offers an extensive selection of economy seating on long haul flights (did someone say Skycouch)  We recommend choosing your preferences early to enjoy the best available options.',
							notes: "Working days are Mon, Tue & Thu.",
							email: "karen.koval@airnz.co.nz",
							phoneNumber: "+61 414 747 238",
							image: "Karen.K.jpg",
							bookings:
								"mailto:karen.koval@airnz.co.nz",
							videoIntroduction: '/video/bdm/Karen%20AIRNZ-32681-C-1%20%E2%80%A2%20Sydney%20BDM%20Introduction%20Videos%20%E2%80%A2%20Deliverable%20%E2%80%A2%20NA%20%E2%80%A2%20240130.mov',
						},
						{
							firstName: "Kate",
							lastName: "Aitken",
							leisureCorporate: "National Group Sales BDM",
							location:
								"National",
							funFact:
								"I have never once missed a flight and have worked in the travel industry for 14 years.",
							salesTipHeadline: "Groups - 2x 23kg Bags",
							salesTip: 'For groups, the inclusion of two checked 23kg bags per person on our long haul routes is a key advantage. Making it easy to travel with bulky equipment while avoiding excess baggage fees.',
							email: "kate.aitken@airnz.co.nz",
							phoneNumber: "+61 420 472 648",
							image: "kate.aitken.png",
							bookings:
								"mailto:kate.aitken@airnz.co.nz",
						},
					],
				},
				{
					state: "VIC",
					name: "Victoria",
					bdmList: [
						{
							firstName: "Melissa",
							lastName: "Train",
							leisureCorporate: "Leisure Sales BDM - VIC",
							location:
								"Victoria",
							funFact:
								"New York, the heartbeat of the world, is my all time favourite city.  I am lucky to have visited 7 times!",
							salesTipHeadline: "Premium Economy",
							salesTip: 'Sell the new Premium Economy experience on our Dreamliner 787 - a boutique cabin with dedicated crew and amenities, a generous 41" pitch, 8" recline and cushy leg rest, plus a fixed shell seat that means no one will be reclining into your space!',
							email: "melissa.train@airnz.co.nz",
							phoneNumber: "+61 414 691 812",
							image: "Mellisa.T.jpg",
							bookings:
								"mailto:melissa.train@airnz.co.nz",
						},
						{
							firstName: "Thalia",
							lastName: "Ashley",
							leisureCorporate: "Corporate & TMC BDM - VIC",
							location:
								"Victoria",
							funFact:
								"I enjoy going to live music events and concerts, and secretly wish I could sing.",
							salesTipHeadline: "Flexi Fares",
							salesTip: 'Book your customers worksflexi for flexible, refundable fares and no change fee, perfect for  stress-free holidays to New Zealand and the Pacific Islands.',
							email: "thalia.ashley@airnz.co.nz ",
							phoneNumber: "+61 414 697 443",
							image: "Thalia.A.jpg",
							bookings:
								"mailto:thalia.ashley@airnz.co.nz",
							videoIntroduction: '/video/bdm/Thalia%20AIRNZ-32681-B-1%20%E2%80%A2%20Sydney%20BDM%20Introduction%20Videos%20%E2%80%A2%20Deliverable%20%E2%80%A2%20NA%20%E2%80%A2%20240130.mov',
						},
						{
							firstName: "Kate",
							lastName: "Aitken",
							leisureCorporate: "National Group Sales BDM",
							location:
								"National",
							funFact:
								"I have never once missed a flight and have worked in the travel industry for 14 years.",
							salesTipHeadline: "Groups - 2x 23kg Bags",
							salesTip: 'For groups, the inclusion of two checked 23kg bags per person on our long haul routes is a key advantage. Making it easy to travel with bulky equipment while avoiding excess baggage fees.',
							email: "kate.aitken@airnz.co.nz",
							phoneNumber: "+61 420 472 648",
							image: "kate.aitken.png",
							bookings:
								"mailto:kate.aitken@airnz.co.nz",
						},
					],
				},
				{
					state: "WA&NT",
					name: "Western Australia and Northern Territory",
					bdmList: [
						{
							firstName: "Janelle",
							lastName: "Philpott",
							leisureCorporate: "Leisure Sales and Corporate & TMC BDM - WA/NT",
							location:
								"Western Australia and Northern Territory",
							funFact:
								"I was lucky enough to travel to Graceland and visit the birthplace of Elvis.",
							salesTipHeadline: "Flexi Fares",
							salesTip: 'Flexi fares are a great option for clients who need the flexibility to change or move their travel plans. They are especially good value on flights departing from Western Australia.',
							email: "janelle.philpott@airnz.co.nz",
							phoneNumber: "+61 438 816 573",
							image: "Janelle.P.jpg",
							bookings:
								"mailto:janelle.philpott@airnz.co.nz",
							videoIntroduction: '/video/bdm/Janelle%20AIRNZ-32681-D-1%20%E2%80%A2%20Sydney%20BDM%20Introduction%20Videos%20%E2%80%A2%20Deliverable%20%E2%80%A2%20NA%20%E2%80%A2%20240130.mov',
						},
						{
							firstName: "Kate",
							lastName: "Aitken",
							leisureCorporate: "National Group Sales BDM",
							location:
								"National",
							funFact:
								"I have never once missed a flight and have worked in the travel industry for 14 years.",
							salesTipHeadline: "Groups - 2x 23kg Bags",
							salesTip: 'For groups, the inclusion of two checked 23kg bags per person on our long haul routes is a key advantage. Making it easy to travel with bulky equipment while avoiding excess baggage fees.',
							email: "kate.aitken@airnz.co.nz",
							phoneNumber: "+61 420 472 648",
							image: "kate.aitken.png",
							bookings:
								"mailto:kate.aitken@airnz.co.nz",
						},
					],
				},
			],
		};
	},
};
</script>
